module.exports = __webpack_public_path__ + "img/icon-logout.bc1d3101.svg";